export const KEYS = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
export const SCALES = ["Major", "Minor", "Dorian", "Phrygian", "Harmonic Minor", "Mixolydian"];
export const MOODS = [
  "Haunting Cathedral",
  "Vampiric Duet",
  "Ethereal Ghost",
  "Aggressive Metal Choir",
  "Gregorian Chant",
  "Dark Pop Hook",
];

export const INTERVALS = [
  { id: "m3-up", label: "Minor 3rd", short: "+3", semitones: 3 },
  { id: "M3-up", label: "Major 3rd", short: "+4", semitones: 4 },
  { id: "P4-up", label: "Perfect 4th", short: "+5", semitones: 5 },
  { id: "P5-up", label: "Perfect 5th", short: "+7", semitones: 7 },
  { id: "oct-up", label: "Octave Up", short: "+12", semitones: 12 },
  { id: "m3-down", label: "Minor 3rd Below", short: "-3", semitones: -3 },
  { id: "P4-down", label: "4th Below", short: "-5", semitones: -5 },
  { id: "oct-down", label: "Octave Down", short: "-12", semitones: -12 },
];

export const SCALE_STEPS = {
  Major: [0, 2, 4, 5, 7, 9, 11],
  Minor: [0, 2, 3, 5, 7, 8, 10],
  Dorian: [0, 2, 3, 5, 7, 9, 10],
  Phrygian: [0, 1, 3, 5, 7, 8, 10],
  "Harmonic Minor": [0, 2, 3, 5, 7, 8, 11],
  Mixolydian: [0, 2, 4, 5, 7, 9, 10],
};

const DEG_NAMES = ["Unison", "2nd", "3rd", "4th", "5th", "6th", "7th", "Octave"];
export const stepLabel = (s) => (s === 0 ? "Unison" : `${DEG_NAMES[Math.abs(s)]} ${s > 0 ? "Above" : "Below"}`);
export const approxSemis = (s) => Math.sign(s) * [0, 2, 4, 5, 7, 9, 11, 12][Math.abs(s)];

export const KEY_INTERVALS = [
  { id: "k3-up", steps: 2, short: "3rd↑" },
  { id: "k4-up", steps: 3, short: "4th↑" },
  { id: "k5-up", steps: 4, short: "5th↑" },
  { id: "k6-up", steps: 5, short: "6th↑" },
  { id: "k8-up", steps: 7, short: "8ve↑" },
  { id: "k3-down", steps: -2, short: "3rd↓" },
  { id: "k4-down", steps: -3, short: "4th↓" },
  { id: "k8-down", steps: -7, short: "8ve↓" },
].map((i) => ({ ...i, label: stepLabel(i.steps) }));

export const KEY_COMBOS = [
  { id: "kcathedral", label: "Cathedral Choir", steps: [2, 4, -7] },
  { id: "kpower", label: "Power Stack", steps: [4, 7] },
  { id: "kghost", label: "Ghost Octaves", steps: [7, -7] },
  { id: "ktriad", label: "Triad Above", steps: [2, 4] },
];

export const COMBOS = [
  { id: "cathedral", label: "Cathedral Choir", parts: [3, 7, -12] },
  { id: "power", label: "Power Stack", parts: [7, 12] },
  { id: "ghost", label: "Ghost Octaves", parts: [12, -12] },
  { id: "triad", label: "Major Triad", parts: [4, 7] },
];

export const nameFor = (st) => INTERVALS.find((i) => i.semitones === st)?.label || `${st > 0 ? "+" : ""}${st} st`;

export function colorFor(st) {
  const a = Math.abs(Math.round(st));
  if (a === 0) return "#E5A93C";
  if (a === 3 || a === 4) return "#C92A3E";
  if (a === 5 || a === 7) return "#8B5CF6";
  if (a === 12) return "#38BDF8";
  return "#10B981";
}

export const AUDIO_ACCEPT = "audio/*,.mp3,.wav,.m4a,.aac,.flac,.ogg,.oga,.opus,.aif,.aiff,.webm";
export const MAX_UPLOAD_MB = 50;

export const SONG_COLOR = "#A89FA8";

const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));

export const newTrack = (patch) => ({
  id: uid(),
  name: "Lead Vocal",
  kind: "lead",
  semitones: 0,
  mode: "fixed",
  degrees: 0,
  trim: 0,
  start: 0,
  volume: 0.8,
  pan: 0,
  mute: false,
  solo: false,
  eq_low: 0,
  eq_mid: 0,
  eq_high: 0,
  reverb: 0.25,
  delay: 0,
  ...patch,
  color: patch.kind === "backing" ? SONG_COLOR : colorFor(patch.mode === "diatonic" ? approxSemis(patch.degrees) : patch.semitones || 0),
});

export const fmtTime = (t) => {
  const m = Math.floor(t / 60);
  const s = (t % 60).toFixed(2).padStart(5, "0");
  return `${String(m).padStart(2, "0")}:${s}`;
};
